import React from 'react';
import './resume.css';
import {SkillBar} from './SkillBar/skillBar';
import {useState} from 'react';
import WorkOutlineIcon from '@material-ui/icons/WorkOutline';

export function Resume(props) {
    const [skillData, setSkillData] = useState({
        skills: [
            {
                name:'HTML5',
                percent: '95%'
            }, 
            {
                name:'javascript',
                percent: '80%'
            }, 
            {
                name:'Reactjs', 
                percent: '60%'
            }, 
            {
                name:'Angular 8', 
                percent: '60%'
            }, 
            {
                name:'CSS3', 
                percent: '70%'
            },
            {
                name:'C++', 
                percent: '70%'
            }
        ]
    });
    return (
        <div className = 'about container'>
            <div className = 'header row'>
                <h2>Skills</h2>
            </div>
            <div className = 'row'>
                <div className = 'col-md-6'>
                    <SkillBar skillData = {skillData.skills[0]}/>
                    <SkillBar skillData = {skillData.skills[1]}/>
                    <SkillBar skillData = {skillData.skills[2]}/>
                </div>
                <div className = 'col-md-6'>
                    <SkillBar skillData = {skillData.skills[3]}/>
                    <SkillBar skillData = {skillData.skills[4]}/>
                    <SkillBar skillData = {skillData.skills[5]}/>
                </div>           
        </div>
        <div className = 'header row mt-5 pt-5'>
                <h2>Resume </h2>
        </div>
        <div className = 'subtitle'>
            <span className = 'subtitle-icon'>
            <WorkOutlineIcon style = {{fontSize: 30}} className = 'mb-2'/>
            </span>
            <h4> Work Experience</h4>
        </div>
        <div className = 'resume-wrapper'>
            <div className = 'resume-data mt-5'>
                <div className = 'resume-summary'>
                    <h6 className = 'resume-year'> 2019  -  Present</h6>
                </div>
            </div>
            <div className = 'resume-details mt-5'>
                <h5> Software Engineer</h5>
                <h6 className = 'resume-company'> Optimus Information</h6>
                <p> Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quas, magni mollitia, 
                    aspernatur consequatur accusamus vero eum facere exercitationem velit 
                    suscipit ipsam placeat libero. Deleniti exercitationem nostrum quasi. 
                    Molestiae, vel porro.
                </p>
            </div>
        </div>

                <div className = 'resume-wrapper'>
            <div className = 'resume-data mt-5'>
                <div className = 'resume-summary'>
                    <h6 className = 'resume-year'> 2018  -  2019</h6>
                </div>
            </div>
            <div className = 'resume-details mt-5'>
                <h5> Internship</h5>
                <h6 className = 'resume-company'> 360 DT</h6>
                <p> Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quas, magni mollitia, 
                    aspernatur consequatur accusamus vero eum facere exercitationem velit 
                    suscipit ipsam placeat libero. Deleniti exercitationem nostrum quasi. 
                    Molestiae, vel porro.
                </p>
            </div>
        </div>

        <div className = 'resume-wrapper'>
            <div className = 'resume-data mt-5'>
                <div className = 'resume-summary'>
                    <h6 className = 'resume-year'> 2017  -  2018</h6>
                </div>
            </div>
            <div className = 'resume-details mt-5'>
                <h5> Internship</h5>
                <h6 className = 'resume-company'>SMS PVT LTD</h6>
                <p> Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quas, magni mollitia, 
                    aspernatur consequatur accusamus vero eum facere exercitationem velit 
                    suscipit ipsam placeat libero. Deleniti exercitationem nostrum quasi. 
                    Molestiae, vel porro.
                </p>
            </div>
        </div>


        <div className = 'subtitle mt-5'>
            <span className = 'subtitle-icon'>
                <WorkOutlineIcon style = {{fontSize: 30}} className = 'mb-2'/>
            </span>
            <h4> Education Qualifications</h4>
        </div>
        <div className = 'resume-wrapper'>
            <div className = 'resume-data mt-5'>
                <div className = 'resume-summary'>
                    <h6 className = 'resume-year'> 2015  -  2019</h6>
                </div>
            </div>
            <div className = 'resume-details mt-5'>
                <h5> Bachelor in Electronics and Communication</h5>
                <h6 className = 'resume-company'> Manipal Jaipur</h6>
                <p> Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quas, magni mollitia, 
                    aspernatur consequatur accusamus vero eum facere exercitationem velit 
                    suscipit ipsam placeat libero. Deleniti exercitationem nostrum quasi. 
                    Molestiae, vel porro.
                </p>
            </div>
        </div>

                <div className = 'resume-wrapper'>
            <div className = 'resume-data mt-5'>
                <div className = 'resume-summary'>
                    <h6 className = 'resume-year'> 2013  -  2015</h6>
                </div>
            </div>
            <div className = 'resume-details mt-5'>
                <h5> High School</h5>
                <h6 className = 'resume-company'> Tagore International School </h6>
                <p> Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quas, magni mollitia, 
                    aspernatur consequatur accusamus vero eum facere exercitationem velit 
                    suscipit ipsam placeat libero. Deleniti exercitationem nostrum quasi. 
                    Molestiae, vel porro.
                </p>
            </div>
        </div>

        </div>
    );
}
